import { axiosInstance } from '../axios';

const API_URL = '/api/defectreports';

class DefectReportsService {

  async list(params) {

    let queryParams = new URLSearchParams();
    for (const [key, value] of Object.entries(params)) {
      if (value === null || value === undefined){
        continue;
      }

      if (key === 'states'){
        params.states.forEach(state =>{
          queryParams.append(key, state);
        });
      } else {
        queryParams.append(key, value);
      }
    }
    return axiosInstance.get(
        `${API_URL}/list`,
        {
          params: queryParams,
        },
    );
  }

  async get(defectReportId) {
    return axiosInstance.get(
        `${API_URL}/get/${defectReportId}`);
  }

  async save(defectReportDTO) {
    return axiosInstance.post(
        `${API_URL}/save`,
        defectReportDTO,
    );
  }

  async delete(defectReportId) {
    let data = new FormData();
    defectReportId.forEach(id => data.append('ids', id) );
    return axiosInstance.delete(
        `${API_URL}/delete`,
        { data:data },
    );
  }
}

export default new DefectReportsService();
